import { render, staticRenderFns } from "./Product-Detail.vue?vue&type=template&id=2e20dc7f"
import script from "./Product-Detail.vue?vue&type=script&lang=js"
export * from "./Product-Detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports